/**
 * @module: 登录注册埋点处理
 * @author: Teacher Tang
 * @date: 2020-02-24 10:44:00
 */

import { utils, cookie } from "@clouderwork/ywk";

export const setUtm = function() {
  let utmSource = utils.getQueryString('utm_source', '') || '';
  let utmMedium = utils.getQueryString('utm_medium', '') || '';
  let utmCampaign = utils.getQueryString('utm_campaign', '') || '';
  let customSource = utils.getQueryString('source', '') || '';
  cookie.set('_utm_source', utmSource);
  cookie.set('_utm_medium', utmMedium);
  cookie.set('_utm_campaign', utmCampaign);
  cookie.set('_source', customSource);
}
